import { render, staticRenderFns } from "./customerChecRecordkPage.vue?vue&type=template&id=5c039edf&scoped=true&"
import script from "./customerChecRecordkPage.vue?vue&type=script&lang=js&"
export * from "./customerChecRecordkPage.vue?vue&type=script&lang=js&"
import style0 from "./customerChecRecordkPage.vue?vue&type=style&index=0&id=5c039edf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c039edf",
  null
  
)

export default component.exports